<div>
    <div style="margin-left: 80%; margin-top: -4%; margin-bottom: 2%">
        <button [useExistingCss]="true" class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
            color="primary" printSectionId="print-section" ngxPrint>
            print
        </button>
        <button mat-dialog-close class="btn noPrint">
            Close
        </button>
    </div>
</div>
<div>
    <div class="container" id="print-section">
        <div style="padding: 0 15%;">
            <div class="row"
                style="border-width: 2px 2px 2px 2px; border-style: solid; border-color: black;text-align: center;">
                <h3 style="margin-left: auto;margin-right: auto;font-weight: 600;"> दि.{{ endDate | date:"dd/MM/yyyy" }} च्या अंकाचे जावक 
                </h3>
            </div>
            <div class="row">
                <div class="col-3" style="border-width: 0 1px 2px 2px; font-weight: 600;">
                    वितरण माध्यम
                </div>
                <div class="col-2" style="border-width: 0 1px 2px 0;font-weight: 600;">
                    वर्गणी प्रती
                </div>
                <div class="col-1" style="border-width: 0 1px 2px 0;font-weight: 600;">
                    विक्री प्रती
                </div>
                <div class="col-1" style="border-width: 0 1px 2px 0;font-weight: 600;">
                    सप्रेम भेट प्रती
                </div>
                  <div class="col-1" style="border-width: 0 1px 2px 0;font-weight: 600;">
                   जादा अंक 
                </div>
                <div class="col-1" style="border-width: 0 1px 2px 0;font-weight: 600;">
                   जादा विक्री 
                </div>
                <div class="col-1" style="border-width: 0 1px 2px 0;font-weight: 600;">
                   जादा सप्रेमभेट 
                </div>
                <div class="col-2" style="border-width: 0 2px 2px 0;font-weight: 600;">
                    एकूण
                </div>
            </div>
            <div class="row">
                <div class="col-3" style="border-width: 1px 1px 0 2px; font-weight: 600;">
                </div>
                <div class="col-2" style="border-width: 1px 1px 0 0;font-weight: 600;">
                    {{ totalVargini }}
                </div>
                <div class="col-1" style="border-width: 1px 1px 0 0;font-weight: 600;">
                    {{ totalVikri }}
                </div>
                <div class="col-1" style="border-width: 1px 1px 0 0;font-weight: 600;">
                    {{ totalSBhet }}
                </div>
                <div class="col-1" style="border-width: 1px 1px 0 0;font-weight: 600;">
                    {{ totalJadaVargini }}
                </div>
                <div class="col-1" style="border-width: 1px 1px 0 0;font-weight: 600;">
                    {{ totalJadaVikriVargini }}
                </div>
                <div class="col-1" style="border-width: 1px 1px 0 0;font-weight: 600;">
                    {{ totalJadaSBhetVargini }}
                </div>
                <div class="col-2" style="border-width: 1px 2px 0 0;font-weight: 600;">
                    {{ totalAikun }}
                </div>
            </div>
            <ng-container *ngFor="let item of tempData;">
                <div class="row">
                    <div class="col-3" style="border-width: 1px 1px 0 2px; font-weight: 600;">
                        {{ item['name'] }}
                    </div>
                    <div class="col-2" style="border-width: 1px 1px 0 0;">
                        <ng-container *ngIf="item.name === 'पोस्ट'">
                            <!-- Always show numeric value even if 0 or string -->
                            {{ item.vprati ? item.vprati : '0' }}
                        </ng-container>
                        <ng-container *ngIf="item.name !== 'पोस्ट'">
                            {{ item.vprati != null && item.vprati !== 0 ? item.vprati : '0' }}
                        </ng-container>
                    </div>
                    <div class="col-1" style="border-width: 1px 1px 0 0;">
                        {{ item['vkprati'] }}
                    </div>
                    <div class="col-1" style="border-width: 1px 1px 0 0;">
                            {{ item.sbprati }}
                    </div>
                     <div class="col-1" style="border-width: 1px 1px 0 0;">
                            {{ item.jadaAnk }}
                    </div>
                    <div class="col-1" style="border-width: 1px 1px 0 0;">
                            {{ item.jadaSale }}
                    </div>
                    <div class="col-1" style="border-width: 1px 1px 0 0;">
                            {{ item.jadaSBhet }}
                    </div>
                    <div class="col-2" style="border-width: 1px 2px 0 0;font-weight: 600;">
                        {{ item['aikun'] }}
                    </div>
                </div>
            </ng-container>
            <div class="row">
                <div class="col-3" style="border-width: 2px 1px 0 2px; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black;">
                    {{ tempDataTotal['name'] }}
                </div>
                <div class="col-2" style="border-width: 2px 1px 0 0; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black;">
                    {{ tempDataTotal['totalVprati'] }}
                </div>
                <div class="col-1" style="border-width: 2px 1px 0 0; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black;">
                    {{ tempDataTotal['totalVkprati'] }}
                </div>
                <div class="col-1" style="border-width: 2px 1px 0 0; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black;">
                    {{ tempDataTotal['totalSbhet'] }}
                </div>
                 <div class="col-1" style="border-width: 2px 1px 0 0; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black;">
                    {{ tempDataTotal['totalJadaAnk'] }}
                </div>
                <div class="col-1" style="border-width: 2px 1px 0 0; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black;">
                    {{ tempDataTotal['totalJadaSale'] }}
                </div>
                <div class="col-1" style="border-width: 2px 1px 0 0; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black;">
                    {{ tempDataTotal['totalJadaSBhet'] }}
                </div>
                <div class="col-2" style="border-width: 2px 2px 0 0;font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black;">
                    {{ tempDataTotal['totalAikun'] }}
                </div>
            </div>
            <div class="row">
                <div class="col-3" style="border-width: 1px 1px 0 2px; font-weight: 600;">शिल्लक
                </div>
                <div class="col-2" style="border-width: 1px 1px 0 0;font-weight: 600;">
                    {{ totalVargini - tempDataTotal['totalVprati'] }}
                </div>
                <div class="col-1" style="border-width: 1px 1px 0 0;font-weight: 600;">
                    {{ totalVikri - tempDataTotal['totalVkprati'] }}
                </div>
                <div class="col-1" style="border-width: 1px 1px 0 0;font-weight: 600;">
                    {{ totalSBhet - tempDataTotal['totalSbhet'] }}
                </div>
                <div class="col-1" style="border-width: 1px 1px 0 0;font-weight: 600;">
                    <!-- {{ totalJadaVargini - tempDataTotal['totalJadaAnk'] }} -->
                      {{0}}
                </div>
                <div class="col-1" style="border-width: 1px 1px 0 0;font-weight: 600;">
                    <!-- {{ totalJadaVikriVargini - tempDataTotal['totalJadaSale'] }} -->
                      {{0}}
                </div>
                <div class="col-1" style="border-width: 1px 1px 0 0;font-weight: 600;">
                    <!-- {{ totalJadaSBhetVargini - tempDataTotal['totalJadaSBhet'] }} -->
                      {{0}}
                </div>
                <div class="col-2" style="border-width: 1px 2px 0 0;font-weight: 600;">
                    <!-- {{ totalAikun - tempDataTotal['totalAikun'] }} -->
                </div>
            </div>
            <div class="row" *ngFor="let item of testData">
                <div class="col-3" style="border-width: 1px 1px 0 2px; font-weight: 600;">
                    {{ item['name'] }}
                </div>
                <div class="col-2" style="border-width: 1px 1px 0 0;">
                </div>
                <div class="col-2" style="border-width: 1px 1px 0 0;">
                </div>
                <div class="col-2" style="border-width: 1px 1px 0 0;">
                </div>
                <div class="col-1" style="border-width: 1px 1px 0 0;">
                </div>
                <div class="col-2" style="border-width: 1px 2px 0 0;font-weight: 600;">
                    {{ item['aikun'] }}
                </div>
            </div>
            <div class="row">
                <div class="col-10" style="border-width: 1px 1px 0 2px; font-weight: bold; text-align: end;">एकूण जावक
                </div>
                 <!-- <div class="col-1" style="border-width: 1px 1px 0 1px; font-weight: 600;">
                </div> -->
                <div class="col-2" style="border-width: 1px 2px 0 0;font-weight: 600;">
                    {{tempDataTotal['totalAikun'] }}
                </div>
            </div>
            <!-- <div class="row" *ngFor="let item of testData2">
                <div class="col-10" style="border-width: 1px 1px 0 1px; font-weight: 600;">
                    {{ item['name'] }}
                </div>
                <div class="col-2" style="border-width: 1px 1px 0 0;font-weight: 600;">
                    {{ item['aikun'] }}
                </div>
            </div> -->




            <div class="row" style="border-width: 0 0 1px 0; border-style: solid; border-color: black;"></div>
            <!-- <div class="row">
                <div class="col-10" style="border-width: 1px 1px 0 2px; font-weight: 600;text-align: end;">
                    एकूण जावक
                </div>
                <div class="col-2" style="border-width: 1px 2px 0 0;font-weight: 600;">
                    {{chapai}}
                </div>
            </div> -->
            <div class="row">
                <div class="col-10" style="border-width: 1px 1px 0 2px; font-weight: bold;text-align: end;">
                  एकूण आदेश (छपाई) 
                </div>
                <!-- <div class="col-1" style="border-width: 1px 1px 0 1px; font-weight: 600;text-align: end;">
                </div> -->
                <div class="col-2" style="border-width: 1px 2px 0 0;font-weight: 600;">
                    {{chapai}}
                </div>
            </div>
            <div class="row">
                <div class="col-10" style="border-width: 2px 1px 0 2px; font-weight: bold; text-align: end;">
                    एकूण शिल्लक
                </div>
                  <!-- <div class="col-1" style="border-width: 1px 1px 0 1px; font-weight: 600; text-align: end;">
                </div> -->
                <div class="col-2" style="border-width: 2px 2px 0 0;font-weight: 600;">
                    {{chapai - tempDataTotal['totalAikun'] }}
                </div>
            </div>



            <div class="row" style="border-width: 0 0 2px 0; border-style: solid; border-color: black;"></div>
        </div>
    </div>
</div>

<div>
    <div style="margin-left: 50%; margin-top: 1%; margin-bottom: 2%">
        <button [useExistingCss]="true" class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
            color="primary" printSectionId="print-section" ngxPrint>
            Print
        </button>
        <button mat-dialog-close class="btn noPrint">
            Close
        </button>
    </div>
</div>